import { Link, useRouterState } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ThemeToggle } from "@/components/theme-toggle";

const links = [
  { to: "/", label: "Logo" },
  { to: "/about", label: "About" },
  { to: "/colors", label: "Colors" },
  { to: "/team", label: "Team" },
  { to: "/pricing", label: "Pricing" },
];

export default function PublicNav() {
  const { location } = useRouterState();

  return (
    <header className="sticky top-0 z-40">
      <div
        className={cn(
          "mx-auto mt-4 max-w-7xl px-4 sm:px-6 lg:px-8",
          // glass background that follows your theme variables
          "rounded-2xl border border-border/50",
          // "bg-background/70 backdrop-blur supports-[backdrop-filter]:bg-background/50"
        )}
      >
        <nav className="flex h-14 items-center gap-3">
          {/* Brand */}
          <Link to="/" className="font-semibold tracking-tight text-foreground">
            <div className="inline-flex items-center gap-2">
              <span className="text-base">Tabbed</span>
            </div>
          </Link>

          {/* Center links */}
          <ul className="ml-6 hidden gap-1 md:flex">
            {links.slice(1).map((l) => {
              const active = location.pathname === l.to;
              return (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className={cn(
                      "rounded-xl px-3 py-2 text-sm transition",
                      "text-muted-foreground hover:text-foreground hover:bg-accent/60",
                      active && "bg-accent text-accent-foreground"
                    )}
                  >
                    {l.label}
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* Right actions */}
          <div className="ml-auto flex items-center gap-2">
            <Link to="/sign-in" preload={false}>
              <Button
                variant="secondary"
                className="h-9 rounded-xl border border-border/50 bg-secondary text-secondary-foreground hover:bg-secondary/80"
              >
                Sign in
              </Button>
            </Link>
            <Link to="/sign-up" preload={false}>
              <Button className="h-9 rounded-xl bg-primary text-primary-foreground hover:opacity-90">
                Get started
              </Button>
            </Link>
            <ThemeToggle />
          </div>
        </nav>
      </div>
    </header>
  );
}
